import { cadenzaSessionStorage } from 'cadenza/utils/session-storage/session-storage';

const KEY_CONFIRM_LOAD_HIGH_RESULT_COUNT = 'confirmed.timeline3dHighResultCount';
const KEY_COLLAPSED_RESULT_COUNT_WARNING = 'collapsed.timeline3dHighResultCountWarning';
const KEY_COLLAPSED_TRUNCATED_RESULT_WARNING = 'collapsed.timeline3dTruncatedResultWarning';
const KEY_SELECTED_LAYER = 'selectedLayer';

// user confirmed she wants to loads high result count
export function hasConfirmedLoadHighResultCountForMap (contextKey) {
  return getFlagFromSessionStorage(
    buildScopedKey(KEY_CONFIRM_LOAD_HIGH_RESULT_COUNT, contextKey),
    false
  );
}

export function setConfirmedLoadHighResultCountForMap (contextKey) {
  cadenzaSessionStorage.setItem(buildScopedKey(KEY_CONFIRM_LOAD_HIGH_RESULT_COUNT, contextKey), 'true');
}

// collapsed state for the high result count warning
export function isHighResultCountWarningCollapsed (contextKey) {
  return getFlagFromSessionStorage(
    buildScopedKey(KEY_COLLAPSED_RESULT_COUNT_WARNING, contextKey),
    true);
}

export function setHighResultCountWarningCollapsed (contextKey, value) {
  cadenzaSessionStorage.setItem(buildScopedKey(KEY_COLLAPSED_RESULT_COUNT_WARNING, contextKey), value);
}

// collapsed state for the truncated result warning
export function isTruncatedResultWarningCollapsed (contextKey) {
  return getFlagFromSessionStorage(
    buildScopedKey(KEY_COLLAPSED_TRUNCATED_RESULT_WARNING, contextKey),
    false);
}

export function setTruncatedResultWarningCollapsed (contextKey, value) {
  cadenzaSessionStorage.setItem(buildScopedKey(KEY_COLLAPSED_TRUNCATED_RESULT_WARNING, contextKey), value);
}

// selected layer id for the filter panel
export function getSelectedLayerId (contextKey) {
  return cadenzaSessionStorage.getItem(buildScopedKey(KEY_SELECTED_LAYER, contextKey));
}

export function persistSelectedLayerId (contextKey, value) {
  cadenzaSessionStorage.setItem(buildScopedKey(KEY_SELECTED_LAYER, contextKey), value);
}

// utility functions
function getFlagFromSessionStorage (key, defaultValue) {
  const value = cadenzaSessionStorage.getItem(key);
  if (value === null) {
    cadenzaSessionStorage.setItem(key, defaultValue);
    return defaultValue;
  }
  return value === 'true';
}

function buildScopedKey (baseKey, contextKey) {
  return `timeline3d.${baseKey}[${contextKey}]`;
}
